const emptyChartPlugin = {
    id: 'emptyChart',
    beforeDraw: (chart, args, options) => {
        if (chart.getDatasetMeta(0).data.length !== 0 || options.disableCxone) {
            return;
        }
        const {ctx} = chart;
        ctx.save();
        ctx.globalCompositeOperation = 'destination-over';
        ctx.fillStyle = options.color || '#dadada'; // can change color in chartOptions with options.plugins.emptyChart.color if not set it will default to gray
        ctx.fillRect(0, 0, chart.width, chart.height);
        ctx.restore();
    },
    afterDraw: (chart, args, options) => {
        if (chart.getDatasetMeta(0).data.length !== 0 || options.disableCxone) {
            return;
        }
        const ctx = chart.ctx;
        ctx.save();
        const noDataTxt = "No data available";
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        const centerX = ((chart.chartArea.left + chart.chartArea.right) / 2);
        const centerY = ((chart.chartArea.top + chart.chartArea.bottom) / 2);
        ctx.fillStyle = '#676767';
        ctx.strokeStyle = '#FFFFFF';
        ctx.lineWidth = 1;

        // Draw number in center
        ctx.fillText(noDataTxt, centerX, centerY);
        ctx.restore();
    }
};
export { emptyChartPlugin };
